import SettingsModule, {SettingsMenuTopCategory} from "../../../../core/modules/settings-module";
import {SettingsSection, SettingsSectionTitleDict} from "../../@const";

export default class CustomFieldsSettingsModule extends SettingsModule {

    constructor() {
        super({
            name                     : "Custom Fields",
            description              : "The Custom Fields module empowers users to tailor their workspace by creating various field types for different entities. Whether it's tasks, projects, contacts, or other entities, this module allows users to define and configure fields to capture relevant information efficiently. This flexibility enables streamlined data management, improved organization, and alignment with unique workflows and processes across the platform.",
            svgIcon                  : "isvg-custom-fields",
            typeLabel                : SettingsSectionTitleDict[SettingsSection.TASKS_PROJECTS],
            settingsUrl              : "settings/custom-fields",
            settingsMenuTopCategory  : SettingsMenuTopCategory.ORGANIZATION
        });
    }

}
